/**
 * A short human-readable label for a restaurant location (#41).
 *
 * Lifted out of ReviewForm when Edit Visit gained the same picker (#168) — the
 * two must agree, or the branch you picked on Add reads differently on Edit.
 */
export function locationLabel(loc) {
  const label =
    loc.name ||
    [loc.address, loc.city].filter(Boolean).join(', ') ||
    `Location #${loc.id}`;
  return loc.is_main_location ? `${label} (main)` : label;
}

export default locationLabel;
